<template>
<div class="detail">

    <div class="container p-0" id="job-detail">

        <ol class="breadcrumbs">
            <router-link to="/dashboard">Dashboard</router-link> > <router-link to="/archive">Archive</router-link> > Job#: {{jobid | jobid}}
        </ol>
        <div class="d-sm-flex align-items-top justify-content-between mb-4">
            <h1 class="h3 mb-0 text-gray-800 d-flex align-items-center">Job#: {{jobid | jobid}} <span class="badge badge-lg ml-2" style="font-size:14px;background: rgb(130, 130, 130);">Archived</span></h1>
            <div v-if="user.data.role >= 8" class="no-print d-flex align-items-center align-self-center">
                <button v-if="!eMode && isNotDisabled" @click="toggleEdit()" class="btn btn-secondary"><i class="fas fa-fw fa-edit"></i> Edit Job</button>
                <button v-if="!eMode" @click="printPage()" class="btn btn-info ml-2"><i class="fas fa-fw fa-print"></i> Page</button>
                <label-printer class="ml-2" v-if="job && !eMode" :job="job" />
                <button v-if="eMode" @click="saveChanges()" class="btn btn-primary mr-2">Save Changes</button>
                <button v-if="eMode" @click="toggleEdit()" class="btn btn-warning">Cancel</button>
            </div>
        </div>

        <div v-if="error" class="mb-4 alert alert-danger">{{error}}</div>
        <div v-if="success" class="mb-4 alert alert-success">{{success}}</div>
        <div class="row multi-col" v-if="job && user">
            <div class="col-lg">
                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h5 class="panel-title">Job #{{job.jobid | jobid}} Details</h5>
                    </div>
                    <div class="panel-body">
                        <table class="table focused detail-table">
                            <tbody>
                                <tr>
                                    <th>Date Created</th>
                                    <td>{{job.submitted | fullDate}}

                                        <small>{{job.createdBy}}</small>
                                    </td>
                                </tr>
                                <tr>
                                    <th>Status:</th>
                                    <td v-if="job.status && (!eMode || user.data.role <= 8)" class="pt-2">
                                        <h5 style="margin:auto 0;"><span :title="'Updated: ' + $options.filters.longDate(job.statusChangeDate)" style="margin:auto 0;" :style="{ background: $options.filters.statusHex(job.status)}" class="badge badge-lg">{{job.status}}</span><small style="font-size:12px;display:block;margin-top:2px;margin-bottom:-2px" v-if="job.statusChangeDate">Status Changed: {{job.statusChangeDate | longDate}}</small></h5>
                                    </td>
                                    <td v-if="job.status && eMode && user.data.role > 8" class="p-1">
                                        <select v-model="job.status" name="dataTable_length" required aria-controls="dataTable" class="custom-select form-control mb-0">
                                            <option>Created</option>
                                            <option>Follow Up</option>
                                            <option>Container/eCubes Deployed</option>
                                            <option>Pickup Booked</option>
                                            <option>Transfer</option>
                                            <option>Inwards Recorded</option>
                                            <option>Shred/NZISM</option>
                                            <option>Data Destruction Complete</option>
                                            <option>Dropping Off</option>
                                            <option>Teardown/Processing</option>
                                            <option>Finalise</option>
                                            <option>Invoice</option>
                                            <option>Completed</option>
                                            <option>Cancelled</option>
                                        </select>
                                    </td>

                                </tr>
                                <tr>
                                    <th>Assigned To:</th>
                                    <td class="py-1" v-if="!eMode || user.data.role <= 8">
                                        <div v-if=" job.assignedTo"><span style="padding-right:0.75rem">{{job.assignedTo}}</span><span style="display:inline-block;" v-html="$options.filters.getCaps(job.assignedTo, job.assignedUID, users)"></span></div>
                                        <div class="p-0 py-2 m-0 btn btn-sm" v-if="!job.assignedTo">Unassigned</div>

                                    </td>
                                    <td v-if="eMode && user.data.role > 8" class="p-1">
                                        <select v-model="assignedUser" @change="onChangeAssigned()" name="dataTable_length" required aria-controls="dataTable" class="custom-select form-control mb-0">
                                            <option :value="null">Unassigned</option>
                                            <option :value="user" v-for="(user, i) in users" v-bind:key="i">{{user.name}}</option>
                                        </select>
                                    </td>
                                </tr>
                                <tr v-if="job.custJob || eMode">
                                    <th>Customer Job #</th>
                                    <td v-if="!eMode">{{job.custJob}}</td>
                                    <td v-if="eMode" class="p-1"><input id="custJob" type="text" class="form-control mb-0" name="custJob" v-model="job.custJob" /></td>
                                </tr>
                                <tr>
                                    <th>Arrangmnt/Contract</th>
                                    <td>{{job.return}}</td>
                                </tr>
                                <tr v-if="job.collection">
                                    <th>Collection/Dropoff:</th>
                                    <td>{{job.collection}}</td>
                                </tr>
                                <tr v-if="job.message">
                                    <th>Message:</th>
                                    <td>{{job.message}}</td>
                                </tr>
                                <tr>
                                    <th>Data Destruction:</th>
                                    <td><i title="Data Destruction" v-if="job.datadestruction !== 'No'" class="text-danger fas fa-fw fa-database"></i> {{job.datadestruction}}</td>
                                </tr>
                                <tr v-if="(job.datadestruction === 'Degauss' || job.datadestruction === 'Degauss & Shred')">
                                    <th>Degauss Onsite:</th>
                                    <td> 
                                        {{job.isonsite}}
 
                                </td></tr>
                                <tr v-if="(job.datadestruction === 'Erase' || job.datadestruction === 'Degauss' || job.datadestruction === 'Shred' || job.datadestruction === 'Degauss & Shred') && job.datadestructionEmail && job.datadestructionEmail !== job.email || eMode">
                                    <th>Report Email:</th>
                                    <td>{{job.datadestructionEmail}}</td>
                                </tr>
                                <tr v-if="job.attachment">
                                    <th>Customer Attachment:</th>
                                    <td><a :href="'https://booking.echotech.co.nz/wp-content/themes/blankslate/uploads/'+encodeURIComponent(job.attachment)">{{job.attachment}}</a></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="col-lg">
                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h5 class="panel-title">Contact Details</h5>
                    </div>
                    <div class="panel-body" style="padding:0;">
                        <table class="table focused detail-table">
                            <tbody>
                                <tr v-if="job.organisation || eMode">
                                    <th>Organisation</th>
                                    <td v-if="!eMode">{{getOrgName(job.organisation)}}</td>
                                    <td v-if="eMode" class="p-1">
                                        <select v-model="job.organisation" class="custom-select form-control mb-0">
                                            <option value="">--Select Organisation if Available--</option>
                                            <option :value="org['.key']" v-for="(org, i) in orgs" v-bind:key="i">{{org.name}}</option>
                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                    <th>Business</th>
                                    <td v-if="!eMode">{{job.company}}</td>
                                    <td v-if="eMode" class="p-1"><input id="company" type="text" class="form-control mb-0" name="company" v-model="job.company" /></td>
                                </tr>
                                <tr v-if="job.covidvax === true || job.covidvax === false">
                                    <th>Covid Vax</th>
                                    <td><i title="Covid Vax Requirement" v-if="job.covidvax === true" class="text-warning fas fa-fw fa-exclamation-triangle"></i> <small v-if="job.covidvax === true">Covid Vaccination Certificate Is Required at this Business</small><small v-if="job.covidvax === false">Covid Vax Not Required</small></td>
                                </tr>
                                <tr>
                                    <th>Name</th>
                                    <td v-if="!eMode"><span>{{job.name}}</span></td>
                                    <td v-if="eMode" class="p-1"><input id="name" type="text" class="form-control mb-0" name="name" v-model="job.name" /></td>
                                </tr>
                                <tr>
                                    <th>Email</th>
                                    <td v-if="!eMode">{{job.email}} <br />
                                        <router-link class="no-print" :to="{ name: 'job-search', query: { email:job.email } }">
                                            <small><i class="fas fa-search fa-sm"></i> Other Jobs by User</small>
                                        </router-link>
                                    </td>
                                    <td v-if="eMode" class="p-1"><input id="email" type="email" class="form-control mb-0" name="email" v-model="job.email" /></td>
                                </tr>
                                <tr>
                                    <th>Phone</th>
                                    <td v-if="!eMode"><span>{{job.phone}}</span></td>
                                    <td v-if="eMode" class="p-1"><input id="phone" type="tel" class="form-control mb-0" name="phone" v-model="job.phone" /></td>
                                </tr>
                                <tr v-if="job.altphone || eMode">
                                    <th>Alt Phone</th>
                                    <td v-if="!eMode"><span>{{job.altphone}}</span></td>
                                    <td v-if="eMode" class="p-1"><input id="altphone" type="tel" class="form-control mb-0" name="phone" v-model="job.altphone" /></td>
                                </tr>
                                <tr>
                                    <th>Address</th>
                                    <td v-if="!eMode"><span>{{job.address}}</span> <br />
                                        <a target="_blank" :href="'https://www.google.com/maps/place/' + job.address" class="no-print" style="margin-top:-2px;margin-bottom:-5px;display:block;">
                                            <small><i class="fas fa-map-marker fa-sm"></i> View on Google Maps</small>
                                        </a>

                                    </td>
                                    <td v-if="eMode" class="p-1" style="position:relative;">
                                        <address-autocomplete classes="mb-0" :address.sync="job.address" />

                                    </td>
                                </tr>
                                <tr>
                                    <th>Accounts Email</th>
                                    <td v-if="!eMode">{{job.accounts}}</td>
                                    <td v-if="eMode" class="p-1"><input id="accounts" type="email" class="form-control mb-0" name="accounts" v-model="job.accounts" /></td>
                                </tr>
                                <tr>
                                    <th>Makor #</th>
                                    <td v-if="!eMode">{{job.makorNo}}</td>
                                    <td v-if="eMode" class="p-1"><input id="makorNo" type="number" class="form-control mb-0" name="makorNo" v-model="job.makorNo" /></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="row pt-3 mb-3 card" v-if="job && ((job.attachment && checkIfImage(job.attachment)) || job.itemoption === 'manual') ">
            <div class="col-sm">
                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h5 class="panel-title" v-if="job.itemoption === 'manual'"><i class="fas fa-fw fa-desktop"></i> Items</h5>
                    </div>
                    <div class="panel-body">
                        <a style="max-width:100%;display:block;" v-if="job.attachment && checkIfImage(job.attachment)" :href="'https://booking.echotech.co.nz/wp-content/themes/blankslate/uploads/'+job.attachment"><img style="max-width:100%" :data-src="'https://booking.echotech.co.nz/wp-content/themes/blankslate/uploads/'+job.attachment" :src="'https://booking.echotech.co.nz/wp-content/themes/blankslate/uploads/'+job.attachment" /></a>
                        <table class="fixed fixed-lg" v-if="job.itemoption === 'manual'">

                            <thead>
                                <tr>
                                    <td class="col-address"><strong>Description</strong></td>
                                    <td><strong>Quantity</strong></td>
                                    <td class="col-job" v-if="eMode"></td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, i) in job.items" v-bind:key="i">
                                    <td class="" v-if="!eMode"><strong>{{item.description}}</strong></td>
                                    <td class="p-1" v-if="eMode"><input v-if="eMode" :id="'description'+i" type="text" class="form-control mb-0" :name="'description'+i" v-model="item.description" /></td>
                                    <td v-if="!eMode">{{item.quantity}}</td>
                                    <td v-if="eMode" class="p-1"><input v-if="eMode" :id="'qty'+i" type="text" class="form-control mb-0" :name="'qty'+i" v-model="item.quantity" />
                                    <td class="col-job p-2" v-if="eMode"><button class="btn btn-sm" @click="deleteItem(i, 'items')"><i class="fas text-danger fa-fw fa-trash"></i></button></td>
                                </tr>
                            </tbody>
                            <tfoot v-if="eMode">
                                <td colspan="2"><button @click="addNewItem()" class="btn btn-secondary"><i class="fas fa-fw fa-plus"></i> Add New Item</button></td>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="row pt-3 mb-3 no-print card" v-if="job">
            <div class="col-sm">
                <div class="panel panel-default">
                    <div class="panel-heading d-flex justify-content-between">
                        <h5 class="panel-title"><i class="fas fa-fw fa-file"></i> File Attachments</h5>
                        <file-upload :job="job"></file-upload>
                    </div>
                    <div class="panel-body" v-if="job.adminAttachments && job.adminAttachments.length > 0 || job.attachment">
                        <div class="table-responsive-xl">
                            <div>
                                <table class="fixed fixed-lg">
                                    <thead>
                                        <tr>
                                            <th>Date Uploaded</th>
                                            <th>Entered by</th>
                                            <th class="col-address">File</th>
                                            <th>Size</th>
                                            <th>Last Modified</th>
                                            <th class="col-arrow" v-if="eMode"></th>
                                        </tr>
                                    </thead>
                                    <tbody v-if="job.adminAttachments && job.adminAttachments.length > 0">
                                        <tr class="rw" v-for="(att, i) in job.adminAttachments.slice().reverse()" v-bind:key="i">
                                            <td :time="att.submitted">{{att.submitted | longDate}}</td>
                                            <td><span class="pr-2">{{att.enteredBy}}</span><span style="margin-top:-0.75rem;margin-bottom:-0.75rem;display:inline-block;" v-html="$options.filters.getCaps(att.enteredBy, att.enteredUID, users, true)"></span></td>
                                            <td class="col-address"><a class="d-block mb-1" :href="att.path">{{att.name}}</a></td>
                                            <td>{{Math.floor(att.size / 1000)}}kb</td>
                                            <td :time="att.lastModified">{{att.lastModified | shortDate}}</td>
                                            <td class="col-arrow" v-if="eMode"><button style="margin:-0.75rem;" class="btn btn-sm" @click="deleteItem((job.adminAttachments.length-1) - i, 'adminAttachments')"><i class="fas text-danger fa-fw fa-trash"></i></button></td>
                                        </tr>
                                    </tbody>
                                    <tbody v-if="job.attachment">
                                        <tr class="rw">
                                            <td :time="job.submitted">{{job.submitted | longDate}}</td>
                                            <td><span class="pr-2">Customer ({{job.name}})</span></td>
                                            <td class="col-address"><a class="d-block mb-1" :href="'https://booking.echotech.co.nz/wp-content/themes/blankslate/uploads/'+job.attachment">{{job.attachment}}</a></td>
                                            <td></td>
                                            <td :time="job.submitted">{{job.submitted | shortDate}}</td>
                                            <td class="col-arrow" v-if="eMode"></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row pt-3 mb-3 card" v-if="inwardsList && inwardsList.length>0">
            <div class="col-sm">
                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h5 class="panel-title"><i class="fas fa-fw fa-truck"></i> Inward Goods</h5>
                    </div>
                    <div class="panel-body">
                        <div class="table-responsive-xl">
                            <div>
                                <table class="fixed fixed-lg">
                                    <thead>
                                        <tr>
                                            <th class="col-date">Added</th>
                                            <th class="col-job">Job#</th>
                                            <th class="col-date">Branch</th>
                                            <th>From</th>
                                            <th>Site/Location</th>
                                            <th class="col-date">Carrier/Consignment</th>
                                            <th>Entered by</th>
                                            <th class="col-sm">#Items</th>
                                            <th class="col-sm">Weight</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr class="rw" v-for="(inward, index) in inwardsList" v-bind:key="index">
                                            <td class="col-date" :time="inward.submitted">{{inward.submitted | shortDate}}</td>
                                            <td class="col-job" v-if="!inward.miscDrop">{{inward.jobid | jobid}}</td>
                                            <td class="col-job" v-if="inward.miscDrop">Misc. Drop</td>
                                            <td class="col-date">{{inward.branch | branchFilter}}</td>
                                            <td>{{inward.from}}</td>

                                            <td>{{inward.site}}</td>
                                            <td class="col-date">{{inward.carrier}}</td>
                                            <td><span class="pr-2">{{inward.enteredby}}</span><span style="margin-top:-0.75rem;margin-bottom:-0.75rem;display:inline-block;" v-html="$options.filters.getCaps(inward.enteredby, inward.enteredUID, users, true)"></span></td>
                                            <td class="col-sm">{{inward.numItems}}</td>
                                            <td class="col-sm">{{inward.weight}}kg</td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr class="rw">
                                            <td class="col-date"></td>
                                            <td class="col-job"></td>
                                            <td></td>
                                            <td></td>

                                            <td></td>
                                            <td class="col-date"></td>
                                            <td></td>
                                            <td class="col-sm"><strong>{{totalItems}}</strong></td>
                                            <td class="col-sm"><strong>{{totalWeight}}kg</strong></td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row pt-3 mb-3 card" v-if="job && job.organisation && user.data.role > 10">
            <div class="col-sm">
                <div class="panel panel-default">
                    <div class="panel-heading d-flex justify-content-between">
                        <h5 class="panel-title"><i class="fas fa-fw fa-clock"></i> {{getOrgName(job.organisation)}} Timesheet Entry</h5><router-link :to="{ name: 'timesheet', params:{ orgId: getOrgUrl(job.organisation) }}">View All {{getOrgName(job.organisation)}} Hours</router-link>
                    </div>
                    <div class="panel-body">
                        <div class="table-responsive-xl">
                            <div>
                                <table class="fixed fixed-lg">
                                    <thead>
                                        <tr>
                                            <th>Record Date</th>
                                            <th class="col-address">Timesheet Comment</th>
                                            <th class="col-address"></th>
                                            <th class="col-date">Hours Spent</th>
                                            <th class="col-date"></th>
                                            <th class="col-arrow" v-if="eMode"></th>
                                        </tr>
                                    </thead>
                                    <tbody v-if="timesheets && timesheets.length>0">
                                        <tr class="rw" v-for="(timesheet, index) in timesheets" v-bind:key="index">
                                            <td :time="timesheet.dateFor">{{timesheet.dateFor | fullDay}}</td>
                                            <td class="col-address">{{timesheet.message}}</td>
                                            <td class="col-address"><span class="pr-2">Entered: {{timesheet.submitted | shortDate}} by</span><span style="margin-top:-0.75rem;margin-bottom:-0.75rem;display:inline-block;" v-html="$options.filters.getCaps(timesheet.enteredby, timesheet.enteredUID, users, true)">{{timesheet.submitted | shortDate}}</span></td>
                                            <td class="col-date">{{timesheet.hours}}hrs</td>
                                            <td class="col-date"></td>
                                            <td class="col-arrow" v-if="eMode"><button style="margin-top:-0.5rem;margin-bottom:-0.25rem;" class="btn btn-sm" @click="deleteTimesheet(index)"><i class="fas text-danger fa-fw fa-trash"></i></button></td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr class="rw" v-if="timesheets && timesheets.length>0">
                                            <th></th>
                                            <th class="col-address"></th>
                                            <th class="col-address"></th>
                                            <th class="col-date"><strong>{{totalHours}}hr</strong></th>
                                            <td class="col-date"></td>
                                            <td class="col-arrow" v-if="eMode"></td>
                                        </tr>
                                        <tr class="rw">
                                            <td>
                                                <date-picker placeholder="Date of Entry"  :disabled-date="disabledAfterToday" required format="ddd, MMM D YYYY" id="timesheetDate" class="mb-0" name="timesheetDate" v-model="time.date"></date-picker>
                                            </td>
                                            <td class="col-address" colspan="2"><input placeholder="Comment if required" id="timeMsg" type="text" class="form-control mb-0" name="timesheetDate" v-model="time.msg" /></td>
                                            <td class="col-address"><input placeholder="Hrs eg 2.5" required style="max-width:120px;" id="timesheetHours" step='0.05' value='0.00' class="form-control mb-0" name="timesheetHours" v-model="time.hours" /></td>
                                            <td class="col-date"><button type="submit" @click="saveTimesheet" id="saveTimesheet" class="btn btn-secondary"><i class="fas fa-fw fa-plus"></i> Save</button></td>
                                             <td class="col-date"></td>
                                            <td class="col-arrow" v-if="eMode"></td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                        <hr class="no-print" />

                    </div>
                </div>
            </div>
        </div>
        <div class="row pt-3 mb-3 card" v-if="job">
            <div class="col-sm">
                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h5 class="panel-title"><i class="fas fa-fw fa-comment"></i> Notes</h5>
                    </div>
                    <div class="panel-body">
                        <div class="table-responsive-xl" v-if="jobNotes && jobNotes.length>0">
                            <div>
                                  <table class="table focused">
                                    <thead>
                                        <tr>
                                            <th>Date</th>
                                            <th class="col-date">Type</th>
                                            <th>Entered by</th>
                                            <th class="col-address">Message</th>
                                            <th class="col-arrow" v-if="eMode"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr class="rw" v-for="(jobNote, index) in jobNotes" v-bind:key="index">
                                            <td :time="jobNote.submitted">{{jobNote.submitted | longDate}}</td>
                                            <td class="col-date">{{jobNote.type}}</td>
                                            <td><span class="pr-2">{{jobNote.enteredby}}</span><span style="margin-top:-0.75rem;margin-bottom:-0.75rem;display:inline-block;" v-html="$options.filters.getCaps(jobNote.enteredby, jobNote.enteredUID, users, true)"></span></td>
                                            <td class="col-address">{{jobNote.message}}</td>
                                            <td class="col-arrow" v-if="eMode && jobNote.enteredUID === user.auth.uid"><button style="margin-top:-0.5rem;margin-bottom:-0.25rem;" class="btn btn-sm" @click="deleteNote(index)"><i class="fas text-danger fa-fw fa-trash"></i></button></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <hr class="no-print" />
                        <job-note class="no-print" named="Job" notesRef="jobNotes" :job="job"></job-note>

                    </div>
                </div>
            </div>
        </div>
        <div class="row pt-3 mb-5 no-print card" v-if="job && user.data.role >= 8">
            <div class="col-sm">
                <div class="panel panel-default">
                    <div class="panel-heading d-flex justify-content-between" @click="expandLogSection">
                        <h5 class="panel-title"><i class="fas fa-fw fa-user-edit"></i> Change Log</h5>
                        <button class="btn"><i v-bind:class="{'fa-chevron-down': !expandLog, 'fa-chevron-up': expandLog}" class="fas fa-fw"></i></button>
                    </div>
                    <div class="panel-body" v-bind:class="{'d-none': !expandLog}">

                        <p v-if="changeLogs && changeLogs.length === 0" class="text-center pt-0 pb-4">No Change Logs Created</p>
                        <div class="table-responsive-xl" v-if="changeLogs && changeLogs.length>0">
                            <div>
                                <table class="fixed fixed-lg">
                                    <thead>
                                        <tr>
                                            <th>Date</th>
                                            <th class="col-date">Type</th>
                                            <th>Change Made by</th>
                                            <th class="col-address">Changed From</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr class="rw" v-for="(jobNote, index) in changeLogs" v-bind:key="index">
                                            <td :time="jobNote.submitted">{{jobNote.submitted | longDate}}<button v-if="isNotDisabled" style="margin-top:-0.5rem;margin-bottom:-0.25rem;" class="btn btn-sm" @click="deleteChangeLog(index)"><i class="fas text-danger fa-fw fa-trash"></i></button></td>
                                            <td class="col-date">{{jobNote.type}}</td>
                                            <!--<td>{{job.collection}}</td>-->
                                            <td><span class="pr-2">{{jobNote.enteredby}}</span><span style="margin-top:-0.75rem;margin-bottom:-0.75rem;display:inline-block;" v-html="$options.filters.getCaps(jobNote.enteredby, jobNote.enteredUID, users, true)"></span></td>
                                            <td class="col-address">{{jobNote.message}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
</template>

<script>
import {
    db
} from '../main'

import {
    mapGetters
} from "vuex";

import saveNoteMixin from "../mixins/saveNotes";
import JobNote from "@/components/JobNote";
import FileUpload from "@/components/FileUpload";
import AddressAutocomplete from "@/components/AddressAutocomplete";
import LabelPrinter from "@/components/LabelPrinter";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

const jobs = db.ref("jobsArchive");
const inwardsRef = db.ref("inwardGoods");
const jobNotesRef = db.ref("jobNotes");
const changeLogsRef = db.ref("changeLogs");
const timesheetsRef = db.ref("timesheets");

export default {
    name: "Detail",
    components: {
        JobNote,
        FileUpload,
        AddressAutocomplete,
        LabelPrinter,
        DatePicker
    },
    mixins: [saveNoteMixin],
    //props: ['id'],
    data() {
        return {
            eMode: false,
            changeLogsRaw: [],
            isNotDisabled: false,
            expandLog: false,
            job: null,
            key: this.$route.params.key, //this.$route.params.id
            jobid: parseInt('1' + this.$route.params.id, 10),
            jobsRaw: [],
            inwardsRaw: [],
            inwardsList: [],
            jobNotesRaw: [],
            timesheetsRaw: [],
            time: {},
            users: [],
            error: null,
            assignedUser: null,
            success: null
        };
    },
    firebase: {
        users: db.ref('users').orderByChild('role').limitToLast(50).startAt(8),
    },
    computed: {
        totalItems: function () {
            return this.inwardsList.reduce(function (totalItems, item) {

                return totalItems + item.numItems;
            }, 0);
        },
        totalWeight: function () {
            return this.inwardsList.reduce(function (totalWeight, item) {

                return totalWeight + item.weight;
            }, 0);
        },
        totalHours: function () {
            return this.timesheets.reduce(function (totalHours, item) {

                return parseFloat(totalHours + item.hours);
            }, 0);
        },
        // map `this.user` to `this.$store.getters.user`
        ...mapGetters({
            user: "user",
            orgs: "orgs"
        }),
        jobNotes: function () {
            return [...this.jobNotesRaw].reverse();
        },
        timesheets: function () {
            return [...this.timesheetsRaw].reverse();
        },
        changeLogs: function () {
            return [...this.changeLogsRaw].reverse();
        }
    },
    created() {
        // this.selectedRow(12802);
        this.$store.dispatch('bindOrgs')
    },
    methods: {
        getOrgName(orgId){
            const t =this;
            return t.orgs.filter(org => org['.key'] === orgId)[0].name;
        },
        getOrgUrl(orgId){
            const t =this;
            return t.orgs.filter(org => org['.key'] === orgId)[0].url;
        },
        disabledAfterToday(date) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            return date > today;
        },
        expandLogSection() {
            const t = this;
            t.expandLog = !t.expandLog;
            if (t.job && !t.changeLogs.length > 0) {
                t.$rtdbBind("changeLogsRaw", changeLogsRef.orderByChild("jobid").equalTo(parseInt(this.job.jobid, 10))).then(changeLogsRaw => {
                    // documents will be an array if this.documents was initially set to an array
                    // and it will point to the same property declared in data:
                    //this.jobsRaw === jobsRaw;
                    console.log('changeLogs', changeLogsRaw);
                    console.log('changeLogs', t.changeLogs);
                })
            }
        },
        deleteAttachment(i) {
            const t = this;
            //Remove From User table
            t.job.adminAttachments.splice(i, 1);
            t.saveChanges();
            //Remove User
        },
        deleteNote(i) {
            const t = this;
            db.ref('jobNotes/' + t.jobNotes[i]['.key']).remove();
        },
        deleteChangeLog(i) {
            const t = this;
            db.ref('changeLogs/' + t.changeLogs[i]['.key']).remove();
        },
        deleteTimesheet(i) {
            const t = this;
            console.log('deleteTime', i);
            db.ref('timesheets/' + t.timesheets[i]['.key']).remove();
            t.job.totalHours = t.totalHours;
            t.saveChanges(true);
        },
        printPage() {
            window.print();
        },
        onChangeAssigned() {
            const t = this;
            if (t.assignedUser !== null) {
                t.job.assignedTo = t.assignedUser.name;
                t.job.assignedUID = t.assignedUser['.key'];
            } else {
                t.job.assignedTo = null;
                t.job.assignedUID = null;
            }
        },
        deleteItem(i, item) {
            const t = this;
            console.log(typeof t.job[item]);
            t.job[item].splice(i, 1);
            console.log(t.job[item]);
        },
        toggleEdit() {
            const t = this;
            t.eMode = !t.eMode;
            t.success = null;
            t.error = null;

        },
        saveTimesheet() {
            const t = this;
            console.log(t.user);
            timesheetsRef
                .push({
                    jobid: t.job.jobid,
                    dateFor:  t.time.date.toISOString(),
                    hours: parseFloat(t.time.hours),
                    enteredUID: t.user.auth.uid,
                    enteredby: t.user.data.name,
                    submitted: new Date().toISOString(),
                    message: t.time.msg,
                })
                .then((snap) => {
                    const key = snap.key;
                    console.log(key);
                    console.log("timesheet saved");
                    t.time = {};
                    t.job.totalHours = t.totalHours;
                    t.saveChanges(true);
                });
        },
        saveChanges(dontSaveNote) {
            const t = this;
            console.log('savejob', t.job);
            console.log('jobOriginal', t.jobOriginal);
            if (t.job.status) {
                if (!t.jobOriginal.status) {
                    t.job.statusChangeDate = new Date().toISOString();
                } else {
                    if (t.jobOriginal.status !== t.job.status) {
                        t.job.statusChangeDate = new Date().toISOString();
                    }
                }
                console.log('t.job.statusChangeDate', t.job.statusChangeDate)

            }

            db.ref('jobs2020/' + t.job['.key'])
                .set(t.job)
                .then(() => {
                    console.log('job updated!')
                    t.success = "Job Changes Saved";
                    t.eMode = false;
                    var diff = JSON.stringify(t.diffObj(t.job, t.jobOriginal))
                    console.log('diff', diff);
                    if (diff !== '{}' && !dontSaveNote) {
                        t.saveNote(diff, t.job, 'Edit');
                        t.setJobOriginal();
                    }
                }).catch((error) => {
                    console.error(error);
                });
        },
        addNewItem() {
            var item = {
                description: '',
                item: ''
            }
            this.job.items.push(item);
        },
        checkIfImage(filename) {
            var fileExt = filename.substr(filename.lastIndexOf('.') + 1);
            switch (fileExt.toLowerCase()) {
                case "jpg":
                case "jpeg":
                case "png":
                case "gif":
                    return true;
                default:
                    return false;
            }
        },
        setJobOriginal() {
            const t = this;
            t.jobOriginal = JSON.parse(JSON.stringify(t.job));
            console.log('users', t.users);
            console.log('users', t.jobOriginal);
            setTimeout(function () {
                t.assignedUser = t.users.filter(function (item) {
                    return item['.key'] === t.job.assignedUID;
                })[0];
            }, 1000)
            // console.log('assigned', t.assignedUser);
        }
    },
    watch: {
        key: {
            // call it upon creation too
            immediate: true,
            handler(key) {
                if (key) {
                    const t = this;
                    this.$rtdbBind("job", jobs.child(key)).then(snap => {
                        console.log(snap);
                        console.log('job from Key', t.job);
                        t.setJobOriginal();
                    })
                }
            }
        },
        jobid: {
            // call it upon creation too
            immediate: true,
            handler(jobid) {
                if (!this.key) {
                    console.log('jobid', jobid);
                    const t = this;
                    this.$rtdbBind("jobsRaw", jobs.orderByChild("jobid").equalTo(parseInt(jobid, 10))).then(jobsRaw => {
                        // documents will be an array if this.documents was initially set to an array
                        // and it will point to the same property declared in data:
                        console.log('jobsRaw', jobsRaw[0]);
                        //console.log('t.jobsRaw', t.jobsRaw[0]);
                        if (t.jobsRaw[0]) {
                            t.job = t.jobsRaw[0]
                            t.setJobOriginal();
                        } else {
                            this.error = "Job# " + this.$options.filters.jobid(jobid) + " not found"
                        }
                        //this.jobsRaw === jobsRaw;
                    })
                }
            }
        },
        job: {
            // call it upon creation too
            immediate: true,
            handler(inwardsArr) {
                if (this.job && this.job.inwards && this.job.inwards.length > 0) {
                    console.log('jobid', inwardsArr);
                    this.$rtdbBind("inwardsRaw", inwardsRef.orderByChild("jobid").equalTo(parseInt(this.job.jobid, 10))).then(inwardsRaw => {
                        // documents will be an array if this.documents was initially set to an array
                        // and it will point to the same property declared in data:
                        console.log('inwardsRaw', inwardsRaw);
                        if (this.inwardsRaw && this.inwardsRaw.length > 0) {
                            this.inwardsList = this.inwardsRaw
                        } else {
                            this.error = "Inwards Good for Job# " + this.$options.filters.jobid(this.job.jobid) + " not found"
                        }
                        //this.jobsRaw === jobsRaw;
                    })
                }
                if (this.job) {
                    this.$rtdbBind("jobNotesRaw", jobNotesRef.orderByChild("jobid").equalTo(parseInt(this.job.jobid, 10))).then(jobNotesRaw => {
                        // documents will be an array if this.documents was initially set to an array
                        // and it will point to the same property declared in data:
                        //this.jobsRaw === jobsRaw;
                        console.log('jobNotes', jobNotesRaw);
                        //console.log('jobNotes', this.jobNotes);
                    })
                }
                if (this.job && this.job.organisation) {
                    this.$rtdbBind("timesheetsRaw", timesheetsRef.orderByChild("jobid").equalTo(parseInt(this.job.jobid, 10))).then(timesheetsRaw => {
                        // documents will be an array if this.documents was initially set to an array
                        // and it will point to the same property declared in data:
                        //this.jobsRaw === jobsRaw;
                        console.log('timesheetsRaw', timesheetsRaw);
                        //console.log('jobNotes', this.jobNotes);
                    })
                }
            }
        }
    }
};
</script>

<style>
.panel-title {
    margin-bottom: .75rem;
}

.panel-heading .btn {
    margin-top: -.75rem;
    margin-bottom: -.25rem;
}
</style>
